import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';


export const GroupedMenuFooter = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu-footer')}>{children}</div>
	);
}

GroupedMenuFooter.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenuFooter.defaultProps = {
	className: '',
};
